const notificationDomains = {
  DR: "RFI",
  PIGE: "Pige",
};

export default notificationDomains;
